import { render } from "./KanbanPage.vue?vue&type=template&id=0a7a2044&ts=true"
import script from "./KanbanPage.vue?vue&type=script&lang=ts"
export * from "./KanbanPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__